import { render } from "./corner-right-up.vue?vue&type=template&id=7dfd7916"
const script = {}
script.render = render

export default script